<template>
  <div>
    <button
        class="btn btn-primary "
        v-bind="$attrs"
        @click="pdf"
      >
      <i class="fa fa-print"></i>
        พิมพ์
    </button>
    <pdf-viewer ref="pdfViewerRef"></pdf-viewer>
  </div>
  
</template>


<script>

import PdfViewer from "../../components/modals/forms/PdfViewer.vue";

export default {
  components: { PdfViewer },
  props: {
    transferCode: String,
    transferBranch: String
  },
  methods: {
    pdf() {
      
      let url = "pdf/transfer/" + this.transferCode + "/" + this.transferBranch;

      this.$http
        .get(url, {
          responseType: "blob",
        })
        .then((res) => {
          // console.log(res, res.data);
          var file = new Blob([res.data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          //window.open(fileURL);
          this.$emit("viewShow")
          this.$refs.pdfViewerRef.show({ url: fileURL });
        });
    },
  }
}
</script>